import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { I18nModule } from '@spartacus/core';
import { GenShippingAccountType } from 'src/app/generac/enums/shipping-account-type.enum';
import { GenActiveCartService } from 'src/app/generac/features/cart/core/facade/active-cart.service';

@Component({
  selector: 'gen-checkout-shipping-accounts-selector',
  templateUrl: './checkout-shipping-accounts-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
    NgSelectModule,
    FormsModule,
  ]
})
export class GenCheckoutShippingAccountsSelectorComponent implements OnInit {
  @Input() shippingAccountSelected: GenShippingAccountType;
  @Input() disableDealerShippingAccount: boolean;
  @Input() dealerShippingAccountsError: boolean;
  @Output() shippingAccountChanged: EventEmitter<GenShippingAccountType> = new EventEmitter();

  shippingAccounts: any[] = [{
    name: 'Use Generac’s shipping account',
    code: GenShippingAccountType.GENERAC,
  },
  {
    name: 'Use Dealer’s shipping account',
    code: GenShippingAccountType.DEALER,
  },
  ]

  constructor(
    protected checkoutStepService: CheckoutStepService,
    protected activatedRoute: ActivatedRoute,
    protected activeCartFacade: GenActiveCartService,
  ) {
  }

  ngOnInit(): void {
    if (!this.shippingAccountSelected || this.disableDealerShippingAccount) {
      this.shippingAccountSelected = this.shippingAccounts[0].code;

      if(this.disableDealerShippingAccount) {
        this.shippingAccounts = this.shippingAccounts.filter(account => account.code !== GenShippingAccountType.DEALER);
      }
    }

    this.shippingAccountChanged.emit(this.shippingAccountSelected);
  }

  changeShippingAccount(shippingAccount: GenShippingAccountType): void {
    this.shippingAccountChanged.emit(shippingAccount);
  }
}
